import * as getters from './getters'
import * as actions from './actions'

import {
  LOGIN,
  SESSION,
  REGISTER_AUTH,
  LOGOUT,
  SESSION_ACCOUNT,
  SESSION_TEAM,
  LIST_ACCOUNT,
  LIST_ACCOUNTCOUNTRY,
  ALL_ACCOUNT,
  REGISTER_ACCOUNT,
  SHOW_ACCOUNT,
  UPDATE_ACCOUNT,
  REMOVE_ACCOUNT,
  LIST_PROJECT,
  ALL_PROJECT,
  REGISTER_PROJECT,
  SHOW_PROJECT,
  UPDATE_PROJECT,
  REMOVE_PROJECT,
  LIST_USER,
  ALL_USER,
  REGISTER_USER,
  SHOW_USER,
  UPDATE_USER,
  REMOVE_USER,
  LIST_TEAM,
  ALL_TEAM,
  REGISTER_TEAM,
  SHOW_TEAM,
  UPDATE_TEAM,
  REMOVE_TEAM,
  LIST_CAMPAIGN,
  ALL_CAMPAIGN,
  REGISTER_CAMPAIGN,
  SHOW_CAMPAIGN,
  UPDATE_CAMPAIGN,
  REMOVE_CAMPAIGN,
  LIST_SOCIALREASON,
  ALL_SOCIALREASON,
  REGISTER_SOCIALREASON,
  UPDATE_SOCIALREASON,
  LIST_SUPPLIER,
  ALL_SUPPLIER,
  REGISTER_SUPPLIER,
  SHOW_SUPPLIER,
  UPDATE_SUPPLIER,
  ALL_SUPPLIERACCOUNT,
  REGISTER_SUPPLIERACCOUNT,
  UPDATE_SUPPLIERACCOUNT,
  ALL_SUPPLIERSOCIALREASON,
  REGISTER_SUPPLIERSOCIALREASON,
  UPDATE_SUPPLIERSOCIALREASON,
  LIST_CLIENT,
  ALL_CLIENT,
  REGISTER_CLIENT,
  SHOW_CLIENT,
  UPDATE_CLIENT,
  ALL_CLIENTACCOUNT,
  REGISTER_CLIENTACCOUNT,
  UPDATE_CLIENTACCOUNT,
  LIST_BUDGET,
  LIST_BUDGETSTATE,
  ALL_BUDGET,
  SHOW_BUDGET,
  REGISTER_BUDGET,
  UPDATE_BUDGET,
  LIST_BUDGETELEMENT,
  ALL_BUDGETELEMENT,
  SHOW_BUDGETELEMENT,
  REGISTER_BUDGETELEMENT,
  UPDATE_BUDGETELEMENT,
  LIST_TASK,
  LIST_TASKSTATE,
  ALL_TASK,
  REGISTER_TASK,
  SHOW_TASK,
  UPDATE_TASK,
  ALL_TASKVERSION,
  REGISTER_TASKVERSION,
  SHOW_TASKVERSION,
  LIST_EMAIL,
  LIST_EMAILSTATE,
  LIST_EMAILCHECK,
  SHOW_EMAILCHECK,
  ALL_EMAIL,
  REGISTER_EMAIL,
  SHOW_EMAIL,
  UPDATE_EMAIL,
  ALL_EMAILVERSION,
  REGISTER_EMAILVERSION,
  SHOW_EMAILVERSION,
  REGISTER_EMAILCHECK,
  ALL_EMAILCHECK,
  ALL_EMAILCLASSIFICATION,
  SHOW_EMAILCLASSIFICATION,
  REGISTER_EMAILCLASSIFICATION,
  LIST_PROFILE,
  ALL_PROFILE,
  REGISTER_PROFILE,
  SHOW_PROFILE,
  UPDATE_PROFILE,
  REMOVE_PROFILE,
  LIST_HOUR,
  ALL_HOUR,
  REGISTER_HOUR,
  SHOW_HOUR,
  UPDATE_HOUR,
  REMOVE_HOUR,
  LIST_CALENDAR,
  ALL_CALENDAR,
  REGISTER_CALENDAR,
  SHOW_CALENDAR,
  UPDATE_CALENDAR,
  REMOVE_CALENDAR,
  LIST_NOTIFICATION,
  UPDATE_NOTIFICATION,
  ALL_ACCOUNTUSER,
  REGISTER_ACCOUNTUSER,
  UPDATE_ACCOUNTUSER,
  SET_lOADING,
  ALL_NOTIFICATION,
  LIST_LIBRARY,
  ALL_LIBRARY,
  SHOW_LIBRARY,
  REGISTER_LIBRARY,
  UPDATE_LIBRARY,
  REMOVE_LIBRARY,
  LIST_ACTIVITY,
  ALL_ACTIVITY,
  SHOW_ACTIVITY,
  REGISTER_ACTIVITY,
  UPDATE_ACTIVITY,
  REMOVE_ACTIVITY,
  REMOVE_POINT,
} from './mutation-types'

const initialState = {
  isLoading: false,
  session_account: null,
  session_team: null,
  sidebarStatus: false,
  sidebarStatusResponsive: false,
  stateLogin: false,
  users: [],
  user: {},
  current: {
    accounts: [],
  },
  accounts: [],
  accountcountries: [],
  account: {},
  projects: [],
  project: {},
  teams: [],
  team: {},
  campaigns: [],
  campaign: {},
  socialreasons: [],
  socialreason: {},
  suppliers: [],
  supplier: {},
  supplieraccounts: [],
  supplieraccount: {},
  suppliersocialreasons: [],
  suppliersocialreason: {},
  clients: [],
  client: {},
  clientaccounts: [],
  clientaccount: {},
  tasks: [],
  task: {},
  budgets: [],
  budget: {},
  budgetstates: [],
  budgetelements: [],
  budgetelement: {},
  taskstates: [],
  taskversions: [],
  taskversion: [],
  emails: [],
  email: {},
  emailstates: [],
  emailcheck: {},
  emailchecks: [],
  emailversions: [],
  emailversion: {},
  emailclassifications: {},
  emailclassification: {},
  profiles: [],
  profile: {},
  hours: [],
  hour: {},
  calendars: [],
  calendar: {},
  notifications: [],
  notification: {},
  accountusers: [],
  accountuser: {},
  libraries: [],
  library: {},
  activities: [],
  activity: {},
  points: {},
  point: {},
}
// mutations
const mutations = {
  //AUTH
  [LOGIN](state, user) {
    state.user = user
    state.stateLogin = true
    //DEFAULT ACCOUNT SESSION USER
    if (user.role != 1) {
      if (localStorage.session_account) {
        state.session_account = localStorage.session_account
      } else {
        if (user.accounts.length) {
          localStorage.session_account = user.accounts[0].id
          state.session_account = user.accounts[0].id
        }
      }
    }
    //DEFAULT TEAM SESSION USER
    if (user.role != 1) {
      if (localStorage.session_team) {
        state.session_team = localStorage.session_team
      } else {
        if (user.role == 5) {
          localStorage.session_team = 1
          state.session_team = 1
        } else {
          localStorage.session_team = user.team_id
          state.session_team = user.team_id
        }
      }
    }
  },
  [SESSION](state, user) {
    state.user = user
    state.stateLogin = true
    //DEFAULT ACCOUNT SESSION USER
    if (user.role != 1) {
      if (localStorage.session_account) {
        state.session_account = localStorage.session_account
      } else {
        if (user.accounts.length) {
          localStorage.session_account = user.accounts[0].id
          state.session_account = user.accounts[0].id
        }
      }
    }
    //DEFAULT TEAM SESSION USER
    if (user.role != 1) {
      if (localStorage.session_team) {
        state.session_team = localStorage.session_team
      } else {
        if (user.role == 5) {
          localStorage.session_team = 1
          state.session_team = 1
        } else {
          localStorage.session_team = user.team_id
          state.session_team = user.team_id
        }
      }
    }
  },

  [SESSION_ACCOUNT](state, session) {
    state.session_account = session
  },

  [SESSION_TEAM](state, session) {
    state.session_team = session
  },

  [LOGOUT](state, user) {
    state.user = {
      name: '',
      email: '',
    }
    state.stateLogin = false
  },

  //USER
  [LIST_USER](state, users) {
    state.users = users
  },
  [ALL_USER](state, users) {
    state.users = users
  },
  [SHOW_USER](state, current) {
    state.current = current
  },
  [REGISTER_USER](state, user) {
    state.user = user
  },
  [UPDATE_USER](state, current) {
    state.users = state.users.filter((u) => u.id !== current.id)
    state.current = current
    if (state.current.id === state.user.id) {
      state.user = state.current
    }
  },
  [REMOVE_USER](state, user) {
    state.users = state.users.filter((p) => p.id !== user.id)
  },

  //ACCOUNT
  [LIST_ACCOUNT](state, accounts) {
    state.accounts = accounts
  },
  [LIST_ACCOUNTCOUNTRY](state, accountcountries) {
    state.accountcountries = accountcountries
  },
  [ALL_ACCOUNT](state, accounts) {
    state.accounts = accounts
  },
  [SHOW_ACCOUNT](state, account) {
    state.account = account
  },
  [REGISTER_ACCOUNT](state, account) {
    state.account = account
  },
  [UPDATE_ACCOUNT](state, account) {
    state.accounts = state.accounts.filter((item) => item.id !== account.id)
    state.account = account

    if (state.account.id === state.account.id) {
      state.account = state.account
    }
  },
  [REMOVE_ACCOUNT](state, account) {
    state.accounts = state.accounts.filter((item) => item.id !== account.id)
  },

  //PROJECT
  [LIST_PROJECT](state, projects) {
    state.projects = projects
  },
  [ALL_PROJECT](state, projects) {
    state.projects = projects
  },
  [SHOW_PROJECT](state, project) {
    state.project = project
  },
  [REGISTER_PROJECT](state, project) {
    state.project = project
  },
  [UPDATE_PROJECT](state, project) {
    state.projects = state.projects.filter((item) => item.id !== project.id)
    state.project = project
    if (state.project.id === state.project.id) {
      state.project = state.project
    }
  },
  [REMOVE_PROJECT](state, project) {
    state.projects = state.projects.filter((item) => item.id !== project.id)
  },

  //TEAM
  [LIST_TEAM](state, teams) {
    state.teams = teams
  },
  [ALL_TEAM](state, teams) {
    state.teams = teams
  },
  [SHOW_TEAM](state, team) {
    state.team = team
  },
  [REGISTER_TEAM](state, team) {
    state.team = team
  },
  [UPDATE_TEAM](state, team) {
    state.teams = state.teams.filter((item) => item.id !== team.id)
    state.team = team
    if (state.team.id === state.team.id) {
      state.team = state.team
    }
  },
  [REMOVE_TEAM](state, team) {
    state.teams = state.teams.filter((item) => item.id !== team.id)
  },

  //CAMPAIGN
  [LIST_CAMPAIGN](state, campaigns) {
    state.campaigns = campaigns
  },
  [ALL_CAMPAIGN](state, campaigns) {
    state.campaigns = campaigns
  },
  [SHOW_CAMPAIGN](state, campaign) {
    state.campaign = campaign
  },
  [REGISTER_CAMPAIGN](state, campaign) {
    state.campaign = campaign
  },
  [UPDATE_CAMPAIGN](state, campaign) {
    state.campaigns = state.campaigns.filter((item) => item.id !== campaign.id)
    state.campaign = campaign
    if (state.campaign.id === state.campaign.id) {
      state.campaign = state.campaign
    }
  },
  [REMOVE_CAMPAIGN](state, campaign) {
    state.campaigns = state.campaigns.filter((item) => item.id !== campaign.id)
  },

  //SOCIAL_REASONS
  [LIST_SOCIALREASON](state, socialreasons) {
    state.socialreasons = socialreasons
  },
  [ALL_SOCIALREASON](state, socialreasons) {
    state.socialreasons = socialreasons
  },
  [REGISTER_SOCIALREASON](state, socialreason) {
    state.socialreason = socialreason
  },
  [UPDATE_SOCIALREASON](state, socialreason) {
    state.socialreasons = state.socialreasons.filter(
      (item) => item.id !== socialreason.id
    )
    state.socialreason = socialreason
    if (state.socialreason.id === state.socialreason.id) {
      state.socialreason = state.socialreason
    }
  },

  //SUPPLIERS
  [LIST_SUPPLIER](state, suppliers) {
    state.suppliers = suppliers
  },
  [ALL_SUPPLIER](state, suppliers) {
    state.suppliers = suppliers
  },
  [SHOW_SUPPLIER](state, supplier) {
    state.supplier = supplier
  },
  [REGISTER_SUPPLIER](state, supplier) {
    state.supplier = supplier
  },
  [UPDATE_SUPPLIER](state, supplier) {
    state.suppliers = state.suppliers.filter((item) => item.id !== supplier.id)
    state.supplier = supplier
    if (state.supplier.id === state.supplier.id) {
      state.supplier = state.supplier
    }
  },

  //SUPPLIERACCOUNT
  [ALL_SUPPLIERACCOUNT](state, supplieraccounts) {
    state.supplieraccounts = supplieraccounts
  },
  [REGISTER_SUPPLIERACCOUNT](state, supplieraccount) {
    state.supplieraccount = supplieraccount
  },
  [UPDATE_SUPPLIERACCOUNT](state, supplieraccount) {
    state.supplieraccounts = state.supplieraccounts.filter(
      (item) => item.id !== supplieraccount.id
    )
    state.supplieraccount = supplieraccount
    if (state.supplieraccount.id === state.supplieraccount.id) {
      state.supplieraccount = state.supplieraccount
    }
  },

  //SUPPLIERSOCIALREASON
  [ALL_SUPPLIERSOCIALREASON](state, suppliersocialreasons) {
    state.suppliersocialreasons = suppliersocialreasons
  },
  [REGISTER_SUPPLIERSOCIALREASON](state, suppliersocialreason) {
    state.suppliersocialreason = suppliersocialreason
  },
  [UPDATE_SUPPLIERSOCIALREASON](state, suppliersocialreason) {
    state.suppliersocialreasons = state.suppliersocialreasons.filter(
      (item) => item.id !== suppliersocialreason.id
    )
    state.suppliersocialreason = suppliersocialreason
    if (state.suppliersocialreason.id === state.suppliersocialreason.id) {
      state.suppliersocialreason = state.suppliersocialreason
    }
  },

  //CLIENTS
  [LIST_CLIENT](state, clients) {
    state.clients = clients
  },
  [ALL_CLIENT](state, clients) {
    state.clients = clients
  },
  [SHOW_CLIENT](state, client) {
    state.client = client
  },
  [REGISTER_CLIENT](state, client) {
    state.client = client
  },
  [UPDATE_CLIENT](state, client) {
    state.clients = state.clients.filter((item) => item.id !== client.id)
    state.client = client
    if (state.client.id === state.client.id) {
      state.client = state.client
    }
  },

  //CLIENTACCOUNT
  [ALL_CLIENTACCOUNT](state, clientaccounts) {
    state.clientaccounts = clientaccounts
  },
  [REGISTER_CLIENTACCOUNT](state, clientaccount) {
    state.clientaccount = clientaccount
  },
  [UPDATE_CLIENTACCOUNT](state, clientaccount) {
    state.clientaccounts = state.clientaccounts.filter(
      (item) => item.id !== clientaccount.id
    )
    state.clientaccount = clientaccount
    if (state.clientaccount.id === state.clientaccount.id) {
      state.clientaccount = state.clientaccount
    }
  },

  //BUDGET
  [LIST_BUDGET](state, budgets) {
    state.budgets = budgets
  },
  [LIST_BUDGETSTATE](state, budgetstates) {
    state.budgetstates = budgetstates
  },
  [ALL_BUDGET](state, budgets) {
    state.budgets = budgets
  },
  [SHOW_BUDGET](state, budget) {
    state.budget = budget
  },
  [REGISTER_BUDGET](state, budget) {
    state.budget = budget
  },
  [UPDATE_BUDGET](state, budget) {
    state.budgets = state.budgets.filter((item) => item.id !== budget.id)
    state.budget = budget
    if (state.budget.id === state.budget.id) {
      state.budget = state.budget
    }
  },

  //BUDGETELEMENT
  [LIST_BUDGETELEMENT](state, budgetelements) {
    state.budgetelements = budgetelements
  },
  [ALL_BUDGETELEMENT](state, budgetelements) {
    state.budgetelements = budgetelements
  },
  [SHOW_BUDGETELEMENT](state, budgetelement) {
    state.budgetelement = budgetelement
  },
  [REGISTER_BUDGETELEMENT](state, budgetelement) {
    state.budgetelement = budgetelement
  },
  [UPDATE_BUDGETELEMENT](state, budgetelement) {
    state.budgetelements = state.budgetelements.filter(
      (item) => item.id !== budgetelement.id
    )
    state.budgetelement = budgetelement
    if (state.budgetelement.id === state.budgetelement.id) {
      state.budgetelement = state.budgetelement
    }
  },

  //NOTIFICATION
  [LIST_PROJECT](state, projects) {
    state.projects = projects
  },
  [ALL_NOTIFICATION](state, notifications) {
    state.notifications = notifications
  },

  //TASK
  [LIST_TASK](state, tasks) {
    state.tasks = tasks
  },
  [LIST_TASKSTATE](state, taskstates) {
    state.taskstates = taskstates
  },
  [ALL_TASKVERSION](state, taskversions) {
    state.taskversions = taskversions
  },
  [SHOW_TASKVERSION](state, taskversion) {
    state.taskversion = taskversion
  },
  [ALL_TASK](state, tasks) {
    state.tasks = tasks
  },
  [SHOW_TASK](state, task) {
    state.task = task
  },
  [REGISTER_TASK](state, task) {
    state.task = task
  },
  [REGISTER_TASKVERSION](state, taskversion) {
    state.taskversion = taskversion
  },
  [UPDATE_TASK](state, task) {
    state.tasks = state.tasks.filter((item) => item.id !== task.id)
    state.task = task
    if (state.task.id === state.task.id) {
      state.task = state.task
    }
  },

  //POINT
  [REMOVE_POINT](state, point) {
    //
  },

  //EMAIL
  [LIST_EMAIL](state, emails) {
    state.emails = emails
  },
  [LIST_EMAILSTATE](state, emailstates) {
    state.emailstates = emailstates
  },
  [LIST_EMAILCHECK](state, emailchecks) {
    state.emailchecks = emailchecks
  },
  [ALL_EMAILVERSION](state, emailversions) {
    state.emailversions = emailversions
  },
  [SHOW_EMAILVERSION](state, emailversion) {
    state.emailversion = emailversion
  },
  [ALL_EMAIL](state, emails) {
    state.emails = emails
  },
  [SHOW_EMAIL](state, email) {
    state.email = email
  },
  [SHOW_EMAILCHECK](state, emailcheck) {
    state.emailcheck = emailcheck
  },
  [ALL_EMAILCHECK](state, emailchecks) {
    state.emailchecks = emailchecks
  },
  [REGISTER_EMAIL](state, email) {
    state.email = email
  },
  [REGISTER_EMAILVERSION](state, emailversion) {
    state.emailversion = emailversion
  },
  [REGISTER_EMAILCHECK](state, emailcheck) {
    state.emailcheck = emailcheck
  },
  [UPDATE_EMAIL](state, email) {
    state.emails = state.emails.filter((item) => item.id !== email.id)
    state.email = email
    if (state.email.id === state.email.id) {
      state.email = state.email
    }
  },

  //EMAIL CLASIFICATION
  [ALL_EMAILCLASSIFICATION](state, emailclassifications) {
    state.emailclassifications = emailclassifications
  },
  [SHOW_EMAILCLASSIFICATION](state, emailclassification) {
    state.emailclassification = emailclassification
  },
  [REGISTER_EMAILCLASSIFICATION](state, emailclassification) {
    state.emailclassification = emailclassification
  },

  //PROFILE
  [LIST_PROFILE](state, profiles) {
    state.profiles = profiles
  },
  [ALL_PROFILE](state, profiles) {
    state.profiles = profiles
  },
  [SHOW_PROFILE](state, profile) {
    state.profile = profile
  },
  [REGISTER_PROFILE](state, profile) {
    state.profile = profile
  },
  [UPDATE_PROFILE](state, profile) {
    state.profiles = state.profiles.filter((item) => item.id !== profile.id)
    state.profile = profile
    if (state.profile.id === state.profile.id) {
      state.profile = state.profile
    }
  },
  [REMOVE_PROFILE](state, profile) {
    state.profiles = state.profiles.filter((item) => item.id !== profile.id)
  },

  //HOUR
  [LIST_HOUR](state, hours) {
    state.hours = hours
  },
  [ALL_HOUR](state, hours) {
    state.hours = hours
  },
  [SHOW_HOUR](state, hour) {
    state.hour = hour
  },
  [REGISTER_HOUR](state, hour) {
    state.hour = hour
  },
  [UPDATE_HOUR](state, hour) {
    state.hours = state.hours.filter((item) => item.id !== hour.id)
    state.hour = hour
    if (state.hour.id === state.hour.id) {
      state.hour = state.hour
    }
  },
  [REMOVE_HOUR](state, hour) {
    state.hours = state.hours.filter((item) => item.id !== hour.id)
  },

  //CALENDAR
  [LIST_CALENDAR](state, calendars) {
    state.calendars = calendars
  },
  [ALL_CALENDAR](state, calendars) {
    state.calendars = calendars
  },
  [SHOW_CALENDAR](state, calendar) {
    state.calendar = calendar
  },
  [REGISTER_CALENDAR](state, calendar) {
    state.calendar = calendar
  },
  [UPDATE_CALENDAR](state, calendar) {
    state.calendars = state.calendars.filter((item) => item.id !== calendar.id)
    state.calendar = calendar
    if (state.calendar.id === state.calendar.id) {
      state.calendar = state.calendar
    }
  },
  [REMOVE_CALENDAR](state, calendar) {
    state.calendars = state.calendars.filter((item) => item.id !== calendar.id)
  },

  //NOTIFICATION
  [LIST_NOTIFICATION](state, notifications) {
    state.notifications = notifications
  },
  [UPDATE_NOTIFICATION](state, notification) {
    state.notifications = state.notifications.filter(
      (item) => item.id !== notification.id
    )
    state.notification = notification
    if (state.notification.id === state.notification.id) {
      state.notification = state.notification
    }
  },

  //ACCOUNTUSER
  [ALL_ACCOUNTUSER](state, accountusers) {
    state.accountusers = accountusers
  },
  [REGISTER_ACCOUNTUSER](state, accountuser) {
    state.accountuser = accountuser
  },
  [UPDATE_ACCOUNTUSER](state, accountuser) {
    state.accountusers = state.accountusers.filter(
      (item) => item.id !== accountuser.id
    )
    state.accountuser = accountuser
    if (state.accountuser.id === state.accountuser.id) {
      state.accountuser = state.accountuser
    }
  },

  //LIBRARY
  [LIST_LIBRARY](state, libraries) {
    state.libraries = libraries
  },
  [ALL_LIBRARY](state, libraries) {
    state.libraries = libraries
  },
  [SHOW_LIBRARY](state, library) {
    state.library = library
  },
  [REGISTER_LIBRARY](state, library) {
    state.library = library
  },
  [UPDATE_LIBRARY](state, library) {
    state.libraries = state.libraries.filter((item) => item.id !== library.id)
    state.library = library
    if (state.library.id === state.library.id) {
      state.library = state.library
    }
  },
  [REMOVE_LIBRARY](state, library) {
    state.libraries = state.libraries.filter((item) => item.id !== library.id)
  },

  //ACTIVITY
  [LIST_ACTIVITY](state, activities) {
    state.activities = activities
  },
  [ALL_ACTIVITY](state, activities) {
    state.activities = activities
  },
  [SHOW_ACTIVITY](state, activity) {
    state.activity = activity
  },
  [REGISTER_ACTIVITY](state, activity) {
    state.activity = activity
  },
  [UPDATE_ACTIVITY](state, activity) {
    state.activities = state.activities.filter(
      (item) => item.id !== activity.id
    )
    state.activity = activity
    if (state.activity.id === state.activity.id) {
      state.activity = state.activity
    }
  },
  [REMOVE_ACTIVITY](state, activity) {
    state.activities = state.activities.filter(
      (item) => item.id !== activity.id
    )
  },

  //LOADING
  [SET_lOADING](state, loading = false) {
    state.isLoading = loading
  },
}

export default {
  state: { ...initialState },
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/vuex/entity/index.js